/**
 * @file contains graphql client
 */
import { devtoolsExchange } from '@urql/devtools';

import { Client, createClient, Exchange, fetchExchange } from 'urql';

import { GRAPHQL_URL } from '../config';
import { getShouldUseUrqlDevTools } from '../utils/environment';

import authExchange from './exchanges/auth';
import cacheExchange from './exchanges/cache';
import errorExchange from './exchanges/error';
import { refocusExchange } from './exchanges/refocusExchange';
import subscriptionExchange from './exchanges/subscription';

const shouldUseUrqlDevTools = getShouldUseUrqlDevTools();

const exchanges: Exchange[] = [
  /* @ts-expect-error Types mismatch, hopefully will be fixed after update */
  refocusExchange(),
  // The file is generated on build, so this'll resolve as any prior to that
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  cacheExchange as Exchange,
  errorExchange,
  authExchange,
  fetchExchange,
  subscriptionExchange,
];

if (shouldUseUrqlDevTools === true) {
  /* @ts-expect-error Types mismatch, hopefully will be fixed after update */
  exchanges.unshift(devtoolsExchange);
}

const client: Client = createClient({ exchanges, url: GRAPHQL_URL });

export default client;
